//-----------------------
// is adjustment changed
//-----------------------
export default function isAdjustmentChanged(original, now) {
  // console.log('----------------------------')
  // console.log('IN isAdjustmentChanged')

  if (
    original.adj_value != now.adj_value ||
    original.adj_reason != now.adj_reason ||
    original.character_item != now.character_item
  ) {
    // console.log('VALUE CHANGED', original)
    return true
  } else {
    // console.log('VALUE NOT CHANGED ', original)
    return false
  }
}
